import { createSvgIcon } from '@mui/material/utils';

export const RadioUncheckedIcon = createSvgIcon(
    <svg viewBox="0 0 20 20">
        <circle cx="10" cy="10" r="9" fill="none" strokeWidth="2" />
    </svg>,
    "RadioUnchecked"
);

export default RadioUncheckedIcon;
